import { useState, useEffect } from 'react'
import { getBens } from '../../../api'

function useBens(segmento) {
  const [bensAPI, setBensAPI] = useState([])
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function requestBens() {
      let itens = await getBens(segmento)
      setBensAPI(itens.data.lista)
    }
    requestBens().then(() => {
      setIsLoading(false)
    })
  }, [segmento])

  return { bensAPI, isLoading }
}

export default useBens
